// logMixin.js
export default {
    watch: {
        'formData.radius': function(newVal, oldVal) {
            this.logValueChange(newVal, oldVal);
        }
    },
    methods: {
        logValueChange(newVal, oldVal) {
            console.log(`Value changed from ${oldVal} to ${newVal}`);
        }
    }
};
